var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBudget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 496.896,
    height: 496.895,
    viewBox: "0 0 496.896 496.895",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c49442"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d26855"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40715",
    "data-name": "Group 40715",
    transform: "translate(-1113.604 -291.552)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40714",
    "data-name": "Group 40714"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40713",
    "data-name": "Group 40713",
    transform: "translate(6)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_94",
    "data-name": "Ellipse 94",
    cx: 248.448,
    cy: 248.448,
    r: 248.448,
    transform: "translate(1107.604 291.552)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(1107.604 291.562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34551",
    "data-name": "Path 34551",
    d: "M368.571,34.294l-41.2,8.745L318.235,0A188.742,188.742,0,0,1,176.757,107.439c-2.8.45-5.615.822-8.451,1.135a184.008,184.008,0,0,1-21.128,1.213c-4.128,0-8.236-.137-12.285-.411L105.9,138.349l31.5,31.516c3.247.176,6.514.176,9.781.176q10.094,0,19.993-.8c3.58-.274,7.14-.646,10.681-1.076A249.094,249.094,0,0,0,368.571,34.294Z",
    transform: "translate(101.27 326.836)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34552",
    "data-name": "Path 34552",
    d: "M310.22,238.493A247.451,247.451,0,0,0,243.3,69.04l-5.165,42.138-42.921-5.262a187.921,187.921,0,0,1,50.453,172.76c-.509,2.465-1.1,4.891-1.722,7.3a182.2,182.2,0,0,1-6.456,20.013h0l9.781,45.894,39.752-8.432h0a246.137,246.137,0,0,0,15.65-44.056q1.956-7.942,3.5-16.139a248.169,248.169,0,0,0,4.049-44.76Z",
    transform: "translate(186.675 9.935)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34553",
    "data-name": "Path 34553",
    d: "M363.814,268.635a250.855,250.855,0,0,0-33.863-28.327q-6.358-4.4-12.99-8.432h0A248.076,248.076,0,0,0,62.84,230.038l45.8,9.781L97.779,279.453a187.8,187.8,0,0,1,191.461,6.1c2.132,1.369,4.245,2.758,6.319,4.226A181.726,181.726,0,0,1,313.5,303.946l45.308,5.556Z",
    transform: "translate(60.092 -195.94)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34554",
    "data-name": "Path 34554",
    d: "M160.415,113.972,118.061,102.41a249.508,249.508,0,0,0-22.067,15.357q-7.512,5.869-14.535,12.227h0a248.448,248.448,0,0,0-76.784,231.9l26.782-32.768,33.726,27.545A188.117,188.117,0,0,1,119.04,177.277c1.506-1.428,3.032-2.837,4.6-4.226A187.313,187.313,0,0,1,149.5,153.782Z",
    transform: "translate(0 -65.358)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34555",
    "data-name": "Path 34555",
    d: "M194.4,192.283l29.775-29.755A188.566,188.566,0,0,1,75.752,57.221c-1.1-2.269-2.152-4.558-3.15-6.867a180.6,180.6,0,0,1-7.59-20.717L29.231.41,3.33,32.121A245.454,245.454,0,0,0,17.63,75.16c2.152,4.871,4.441,9.781,6.886,14.4A248.9,248.9,0,0,0,225.27,223.172Z",
    transform: "translate(3.184 272.902)",
    fill: "url(#linear-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40712",
    "data-name": "Group 40712",
    transform: "translate(-6 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40701",
    "data-name": "Group 40701",
    transform: "translate(-42.948)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95",
    "data-name": "Ellipse 95",
    cx: 76,
    cy: 76,
    r: 76,
    transform: "translate(1329 461)",
    fill: "#ffbc48"
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\u0422\\u04E9\\u0441\\u04E9\\u0432",
    transform: "translate(1366 544)",
    fill: "#fff",
    fontSize: 25,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u0422\u04E9\u0441\u04E9\u0432")), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_96",
    "data-name": "Ellipse 96",
    transform: "translate(1323 455)",
    fill: "none",
    stroke: "#ffbc48",
    strokeWidth: 6,
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 82,
    r: 82,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 82,
    r: 79,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_97",
    "data-name": "Ellipse 97",
    transform: "translate(1317 449)",
    fill: "none",
    stroke: "#ffbc48",
    strokeWidth: 6,
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 88,
    r: 88,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 88,
    r: 85,
    fill: "none"
  }))))), /*#__PURE__*/React.createElement("text", {
    id: "_1",
    "data-name": 1,
    transform: "translate(1394 343)",
    fill: "#fff",
    fontSize: 40,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1")), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": 2,
    transform: "translate(1564 542)",
    fill: "#fff",
    fontSize: 40,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2")), /*#__PURE__*/React.createElement("text", {
    id: "_3",
    "data-name": 3,
    transform: "translate(1463 737)",
    fill: "#fff",
    fontSize: 40,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3")), /*#__PURE__*/React.createElement("text", {
    id: "_4",
    "data-name": 4,
    transform: "translate(1192 705)",
    fill: "#fff",
    fontSize: 40,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4")), /*#__PURE__*/React.createElement("text", {
    id: "_5",
    "data-name": 5,
    transform: "translate(1158 450)",
    fill: "#fff",
    fontSize: 40,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "5")))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudget);
export default __webpack_public_path__ + "static/media/budget.3d1b3bf935632e6e53d05e28306c6aa6.svg";
export { ForwardRef as ReactComponent };